import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { slideInAndOutAnimation } from '~lmo/animations';

@Component({
  animations: [slideInAndOutAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-home-card',
  styleUrls: ['./lmo-frac-home-card.component.scss'],
  templateUrl: './lmo-frac-home-card.component.html',
})
export class LmoFracHomeCardComponent implements OnInit {
  @Input() public localStorageKey: string;
  @Input() public isLoading = false;
  private get localStorageKeyWithPrefix(): string {
    if (this.localStorageKey) {
      return `card-start-visible:${this.localStorageKey}`;
    }
  }
  private visible$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public visible$: Observable<boolean> = this.visible$$.asObservable();

  constructor() {}

  public ngOnInit() {
    if (this.localStorageKeyWithPrefix) {
      const storageSetting = localStorage.getItem(this.localStorageKeyWithPrefix);
      let visible = false;
      // No setting from the user, default to visible
      if (storageSetting === null) {
        visible = true;
      } else {
        // The user has an existing setting,  use that
        visible = storageSetting === 'true';
      }
      this.visible$$.next(visible);
    }
  }
  public toggleVisibility() {
    const newState = !this.visible$$.value;
    this.visible$$.next(newState);
    if (this.localStorageKeyWithPrefix) {
      localStorage.setItem(this.localStorageKeyWithPrefix, `${newState}`);
    }
  }
}
